import React from 'react';
import Triangle from './Triangle.js';

export default ({sequencerEngine, row}) => {
    let a = [0,1,2,3,4,5,6,7];
    return (
        <div className="row">
          {a.map(x => <Triangle sequencerEngine={sequencerEngine} row={row} part={x}/>)}
        </div>);
};
